module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"layers-loading":"Загрузка слоев"},"en":{"layers-loading":"Layer Loading"}}')
  delete Component.options._Ctor
}
